import React, {
  ReactNode,
  useState,
  useImperativeHandle,
  forwardRef,
  useEffect,
  useRef,
} from "react";
import classNames from "classnames";
import { View } from "@tarojs/components";
import { CSSTransition } from "react-transition-group";
import Button from "../Button";
import { XHComponentCommonProps } from "../../types";
import Mask from "../Mask";
import "./index.scss";

export type DialogProps = {
  header?: string | ReactNode;
  content: string | ReactNode;
  footer?: ReactNode;
  cancelText?: string;
  confirmText?: string;
  showCancel?: boolean;
  visible: boolean;
  onConfirm?: () => void;
  onCancel?: () => void;
  onClose?: () => void;
  tranparent?: boolean;
  portrait?: boolean;
  fancy?: boolean;
  dataTrackId?: string;
} & XHComponentCommonProps;

export type IDialogRef = {
  close: () => void;
  open: () => void;
};
const DialogCom = forwardRef<IDialogRef, DialogProps>((props, fromRef) => {
  const {
    header,
    content,
    className = "",
    visible,
    showCancel = true,
    confirmText = "确定",
    cancelText = "取消",
    footer = false,
    onConfirm,
    onCancel,
    onClose,
    portrait = false,
    tranparent = false,
    fancy = false,
    dataTrackId = "DialogRef",
  } = props;
  const [selfVisible, setSelfVisible] = useState(false);

  useImperativeHandle(fromRef, () => ({
    close,
    open,
  }));

  const nodeRef = useRef(null);

  const close = () => {
    onClose && onClose();
    setSelfVisible(false);
  };

  const open = () => {
    setSelfVisible(true);
  };

  const handleConfirm = () => {
    onConfirm && onConfirm();
    // close();
  };
  const handleCancel = () => {
    onCancel && onCancel();
    close();
  };

  useEffect(() => {
    if (!visible) {
      onClose && onClose();
    }
    setSelfVisible(visible);
  }, [visible]);

  const dialogcls = classNames("xh-dialog-ref", className, {
    show: selfVisible,
  });

  const dialogFooter = (
    <View
      className={classNames("xh-dialog-ref-content-footer-buttons", {
        portrait,
        fancy,
      })}
    >
      {showCancel && (
        <Button
          ghost
          size="full"
          shape="rectangle"
          preventTime={0}
          onClick={handleCancel}
          className="xh-dialog-ref-content-footer-buttons-cancel"
          dataTrackId={`${dataTrackId}_cancel`}
        >
          {cancelText}
        </Button>
      )}
      <Button
        type="primary"
        shape="rectangle"
        size="full"
        ghost={!fancy}
        className="xh-dialog-ref-content-footer-buttons-confirm"
        onClick={handleConfirm}
        preventTime={0}
        dataTrackId={`${dataTrackId}_confirm`}
      >
        {confirmText}
      </Button>
    </View>
  );

  const DialogMain = (
    <View
      className={dialogcls}
      // @ts-ignore
      dataTrackId={dataTrackId}
    >
      <Mask />
      <CSSTransition
        nodeRef={nodeRef}
        in={selfVisible}
        timeout={200}
        classNames="scale"
      >
        <View className={classNames("xh-dialog-ref-content", { tranparent })}>
          {header && (
            <View className="xh-dialog-ref-content-header">{header}</View>
          )}
          <View className="xh-dialog-ref-content-content">{content}</View>
          {footer || (
            <View className="xh-dialog-ref-content-footer">{dialogFooter}</View>
          )}
        </View>
      </CSSTransition>
    </View>
  );
  return DialogMain;
});

export default DialogCom;
